import { BASE_URL, Admin } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IAdmin ,IAdminInput} from "models/admin";

export async function getAdmins(params: string = "") : Promise<IAdmin[]> {
  const response = await axios.get(BASE_URL + Admin + params);
  return response.data;
}
export async function addAdmin(data: IAdminInput) {
  const response = await axios.post(BASE_URL + Admin, data);
  return response.data;
}
export async function editAdmin(data: IAdminInput, id: string) {
  const response = await axios.patch(BASE_URL + Admin + "/" + id , data);
  return response.data;
}

export async function deleteAdmin(id: string) {
  const response = await axios.delete(BASE_URL + Admin + "/" + id );
  return response.data;
}


export const AdminCells: HeadCell[] = [
  {
    id: "userName",
    numeric: false,
    disablePadding: false,
    label: "User Name",
  },
  {
    id: "adminName",
    numeric: false,
    disablePadding: false,
    label: "Full Name",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];
